import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  .success {
    text-align: center;
    font: ${font('default', 'bold', '22px/1.5')};
  }
`
